export default class EditorPrototype {
  id: string;
  mesh_name: string;
  mesh_rotation: number;

  constructor(id: string, mesh_name: string, mesh_rotation: number) {
    this.id = id;
    this.mesh_name = mesh_name;
    this.mesh_rotation = mesh_rotation;
  }
}
